export var PanelCssClass;
(function (PanelCssClass) {
    PanelCssClass["Base"] = "iress-panel";
    PanelCssClass["Padding"] = "iress-panel--padding";
    PanelCssClass["Stretch"] = "iress-panel--stretch";
    PanelCssClass["NoBorderRadius"] = "iress-panel--no-border-radius";
})(PanelCssClass || (PanelCssClass = {}));
export var PanelBackground;
(function (PanelBackground) {
    PanelBackground["Default"] = "default";
    PanelBackground["Alt"] = "alt";
    PanelBackground["Page"] = "page";
    PanelBackground["Transparent"] = "transparent";
})(PanelBackground || (PanelBackground = {}));
//# sourceMappingURL=panel.types.js.map